"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TagsGroup = _interopRequireDefault(require("../../TagsGroup/TagsGroup"));
var _reactRouterDom = require("react-router-dom");
var _TextWithSyllabification = _interopRequireDefault(require("../TextWithSyllabification/TextWithSyllabification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.vacancies-container .item {\n  display: flex;\n  justify-content: space-between;\n  padding-right: 170px;\n  text-decoration: none; }\n  .vacancies-container .item .title {\n    margin: 0px;\n    width: 480px; }\n  .vacancies-container .item .info {\n    display: flex;\n    width: 333px;\n    justify-content: space-between; }\n  .vacancies-container .item .bx--tag {\n    width: max-content; }\n\n@media (max-width: 66rem) {\n  .vacancies-container .item {\n    gap: 16px;\n    padding-right: 0px;\n    flex-direction: column; }\n    .vacancies-container .item .title {\n      margin: 0px;\n      width: auto; }\n  .vacancies-container .info {\n    gap: 16px;\n    flex-direction: column; } }\n";
  const fileName = "Vacancies_Vacancies";
  const element = document.querySelector("style[data-sass-component='Vacancies_Vacancies']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Vacancy = _ref => {
  let {
    item,
    lang
  } = _ref;
  const date = _react.default.useMemo(() => {
    const format = item.v_publication_date.split('-');
    if (format?.length !== 3) return '';
    const day = format[2][0] === '0' ? format[2].slice(1) : format[2];
    const month = format[1][0] === '0' ? format[1].slice(1) : format[1];
    const year = format[0];
    return `${day}.${month}.${year}`;
  }, [item.v_publication_date]);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: `/${lang}/cms/node/${item.id}`,
    className: "item sia-border-01-top sia-padding-03-top sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "title sia-text-12",
    lang: lang
  }, item.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "info"
  }, item.pensum && item.location && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [{
      label: item.pensum || '',
      type: 'primary'
    }, {
      label: item.location || '',
      type: 'quaternary'
    }]
  })), /*#__PURE__*/_react.default.createElement("div", null, date)));
};
const Vacancies = _ref2 => {
  let {
    items,
    lang,
    translate
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "vacancies-container item sia-border-01-bottom"
  }, items?.length > 0 ? items?.map((item, i) => /*#__PURE__*/_react.default.createElement(Vacancy, {
    key: i,
    item: item,
    lang: lang
  })) : /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-12 sia-padding-05-bottom"
  }, translate('cms.vacancies.empty')));
};
var _default = exports.default = Vacancies;